import { Status } from 'domains/models/send_mail_user/status';
import { z } from 'zod';
export const StatusEnum = z.nativeEnum(Status);
